export default __webpack_public_path__ + "static/media/955.d52e968f.png";